import PropTypes from 'prop-types';
import { equals, path } from 'ramda';
import { connect } from 'react-redux';
import { readEndpoint } from 'redux-json-api';

import React, { Component } from 'react';
import { FeatureGroup, Popup, GeoJSON } from 'react-leaflet';

import { selectRailwayById } from '../modules/selectors/railway';

class Railway extends Component {
  static propTypes = {
    // Own props.
    id: PropTypes.string.isRequired,
    railway: PropTypes.shape({}),
  };

  shouldComponentUpdate(nextProps, nextState) {
    const { id: oldId, railway: oldRailway } = this.props;
    const { id: newId, railway: newRailway } = nextProps;

    // Update when the railway id changes.
    if (oldId !== newId) return true;

    // Update when the railway name changes.
    const orn = path(['attributes', 'name'], oldRailway);
    const nrn = path(['attributes', 'name'], newRailway);
    if (orn !== nrn) return true;

    // Update when geojson becomes available or changes.
    const ogj = path(['attributes', 'geojson'], oldRailway);
    const ngj = path(['attributes', 'geojson'], newRailway);
    if (!ogj && ngj) return true;
    if (ogj && ngj && !equals(ogj, ngj)) return true;

    // Don't update otherwise.
    return false;
  };

  render () {
    const { railway } = this.props;
    const name = path(['attributes', 'name'], railway);
    const geom = path(['attributes', 'geojson'], railway);

    if (!geom) {
      console.error('Railway.render(`' + name + '`): no geom!');
      return null;
    }

    return (
      <FeatureGroup>
        <Popup>
          <span>{name}</span>
        </Popup>
        <GeoJSON data={geom} style={{ weight: 1, color: '#000000' }} />
      </FeatureGroup>
    );
  }
};

const mapStateToProps = (state, ownProps) => ({
  railway: selectRailwayById(state, ownProps),
});

const mapDispatchToProps = {
  readEndpoint
};

export default connect(mapStateToProps, mapDispatchToProps)(Railway);
